// extracted by mini-css-extract-plugin
export default {"freeTextDescription":"style--freeTextDescription--cac1c1"};